import { render, staticRenderFns } from "./EditParcel.vue?vue&type=template&id=0e11aac2&"
import script from "./EditParcel.vue?vue&type=script&lang=js&"
export * from "./EditParcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports